
import React from 'react'
import classnames from 'classnames'

import { buildCss, buildHtmlProps } from '../utilities/props'
import { deprecatedProps, globalProps } from '../utilities/globalProps'
import { GlobalEventProps } from '../utilities/globalEventProps'

import Flex from '../pb_flex/_flex'
import FlexItem from '../pb_flex/_flex_item'
import SectionSeparator from '../pb_section_separator/_section_separator'
import TimeStacked from '../pb_time_stacked/_time_stacked'
import DateStacked from '../pb_date_stacked/_date_stacked'

type DateTimeStackedProps = {
  className?: string,
  htmlOptions?: {[key: string]: string | number | boolean | (() => void)},
  id?: string,
  date: Date,
  datetime: Date,
  dark: boolean,
  timeZone?: string,
  showCurrentYear?: boolean,
} & GlobalEventProps

const DateTimeStacked = (props: DateTimeStackedProps): React.ReactElement => {
  if (props.date) deprecatedProps()

  const {
    date,
    datetime,
    dark,
    className,
    htmlOptions = {},
    timeZone = 'America/New_York',
    showCurrentYear = false,
  } = props

  const classes = classnames(
    buildCss('pb_date_time_stacked_kit'),
    globalProps(props),
    className
  )

  return (
    <Flex
        htmlOptions={htmlOptions}
        inline={false}
        vertical="stretch"
        {...props}
        className={classes}
    >
      <FlexItem>
        <DateStacked
            align="right"
            bold
            dark={dark}
            date={date || datetime}
            showCurrentYear={showCurrentYear}
        />
      </FlexItem>

      <SectionSeparator
          className="date-time-padding"
          orientation="vertical"
      />
      <FlexItem>
        <TimeStacked
            dark={dark}
            date={date || datetime}
            timeZone={timeZone}
        />
      </FlexItem>
    </Flex>
  )
}

export default DateTimeStacked
